import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { trapFocus, TrapFocusCleanup } from '@nech/src/helpers/function-helpers';

(function (Drupal, $) {
  drupalComponent('hp_searchfield', {
    selector: '.nech-homepage-search-field',
    shared: {
      displayModal: function ($modalEl: JQuery<HTMLElement>) {
        $modalEl.removeClass('hidden');
        $modalEl.removeAttr('aria-hidden');
        $('html').addClass('overflow-hidden');
      },

      hideModal: function ($modalEl: JQuery<HTMLElement>, $dropdownEl: JQuery<HTMLElement>) {
        $modalEl.addClass('hidden');
        $dropdownEl.removeClass('opacity-1').addClass('opacity-0 -translate-y-full');
        $modalEl.attr('aria-hidden', 'true');
        $('html').removeClass('overflow-hidden');
      },
    },

    instance() {
      const self = this;
      const $el = $(this.selector); // L'input principal
      const $modalSearch = $el.find('.homepage_searchfield--modal-search');
      const $modalDropdown = $modalSearch.find('.modal-search--dropdown');
      const $searchInput = $modalSearch.find('input[name="global-search"]');
      const $hpInput = $el.find('.homepage-searchfield--input');
      const $dropdownEl = $('.modal-search--dropdown');
      const $button = $el.find('.button-container');

      let searchModalTrapCleanup: TrapFocusCleanup | null = null;

      const openModal = () => {
        $(this).trigger('blur');
        self.shared.displayModal($modalSearch);
        searchModalTrapCleanup = trapFocus({
          el: $modalSearch,
          forceAutofocusEl: $searchInput
        });
      };

      const closeModal = () => {
        if (searchModalTrapCleanup) {
          searchModalTrapCleanup();
          searchModalTrapCleanup = null;
        }
        $searchInput.val('');
        self.shared.hideModal($modalSearch, $modalDropdown);
        $hpInput.trigger('focus');
      };

      $el.on('click keypress', () => openModal());
      $button.on('click', (e) => {
        e.stopPropagation();
        openModal();
      });

      // Gestion de la fermeture via le bouton close + escape button
      $modalSearch.find('.modal-search--close-icon-button').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });

      $(document).on('keyup', function (event) {
        if (event.key === 'Escape' && !$modalSearch.hasClass('hidden')) {
          closeModal();
        }
      });

      // Gestion de clic en dehors du composant
      $(document).on('click', function (event) {
        if (
          !$(event.target).closest($hpInput).length &&
          !$(event.target).closest($searchInput).length &&
          !$(event.target).closest($dropdownEl).length &&
          !$modalSearch.hasClass('hidden')
        ) {
          closeModal();
        }
      });
    },
  });
})(Drupal, jQuery);
